import useTranslation from '@/hooks/useTranslation'
/* eslint-disable jsx-a11y/anchor-is-valid */
const NoTopicsMessage = ({ onLinkClick }) => {
  const t = useTranslation()

  const linkClickHandler = e => {
    e.preventDefault()
    onLinkClick()
  }

  return (
    <div style={{ fontSize: 18 }}>
      <p>
        {t('digital_first_view_no_image_message')}{' '}
        <b>
          <a className="cursorpointer" onClick={linkClickHandler} href="#" role="button">
            {t('digital_first_menu_manuals')} {t('digital_first_view_tab')}
          </a>
        </b>
      </p>
    </div>
  )
}

export default NoTopicsMessage
